import React, { useState } from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { testimonials } from '../mock';
import { Star, X } from 'lucide-react';

const Testimonials = () => {
  const [selectedScreenshot, setSelectedScreenshot] = useState(null);

  const openScreenshot = screenshot => {
    setSelectedScreenshot(screenshot);
    document.body.style.overflow = 'hidden';
  };

  const closeScreenshot = () => {
    setSelectedScreenshot(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <SEO
        title="Client Testimonials | Frames by Gaurav in Lucknow"
        description="Read client feedback about wedding, event and portrait photography by Frames by Gaurav in Lucknow."
        keywords="Professional Photographer in India, Best Photographer Near Me, Wedding Photographer, Candid Wedding Photographer, Pre Wedding Photographer, Cinematic Wedding Films, Event Photographer, Portfolio Photographer, Creative Photography Services, Wedding Photographer in Lucknow, Best Wedding Photographer in Lucknow, Pre Wedding Shoot in Lucknow, Candid Photographer in Lucknow, Engagement Photographer in Lucknow, Birthday Event Photographer in Lucknow, Couple Photoshoot in Lucknow, Affordable Photographer in Lucknow, Luxury Wedding Photography, Destination Wedding Photographer India, Cinematic Pre Wedding Shoot, Romantic Pre Wedding Shoot Ideas, Storytelling Wedding Photography, Couple Photoshoot Ideas, Bollywood Style Pre Wedding Shoot, Royal Wedding Photography, Wedding Photography and Videography, Cinematic Wedding Videographer, Wedding Film Maker, Pre Wedding Video Shoot, Creative Wedding Reels, Instagram Reel Wedding Videographer, Candid Photography, Cinematic Photography, Documentary Wedding Photography, Artistic Wedding Photography, Moody Wedding Photography, Aesthetic Photoshoot, Fine Art Wedding Photography, Instagram Worthy Wedding Shoot, Viral Pre Wedding Reels, Trending Wedding Photography Poses, Reels Style Wedding Shoot, Modern Wedding Photography, Best candid wedding photographer for intimate weddings, Affordable pre wedding shoot packages, Cinematic wedding photographer for couples, Creative pre wedding shoot with storytelling, Professional photographer for luxury weddingsphotography reviews lucknow, wedding photographer reviews, client testimonials, frames by gaurav reviews, best rated photographer lucknow, photography feedback"
        canonicalUrl="/testimonials"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'Testimonials - Frames by Gaurav',
          description:
            'What our clients say about their experience with Frames by Gaurav.',
          url: 'https://www.framesbygaurav.com/testimonials',
        }}
      />
      <Layout showGoogleReviews={true}>
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h1 className="text-5xl md:text-6xl font-bold text-center mb-6 tracking-tight">
              Testimonials
            </h1>
            <p className="text-center text-gray-600 text-lg mb-16 max-w-2xl mx-auto">
              What our clients say about their experience with Frames by Gaurav
            </p>

            {/* Testimonials Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {testimonials.map(testimonial => (
                <div
                  key={testimonial.id}
                  className="p-8 border-2 border-gray-200 hover:border-black transition-all duration-300 group hover:scale-105 flex flex-col"
                >
                  {/* Stars */}
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, index) => (
                      <Star
                        key={index}
                        size={20}
                        className="fill-black text-black"
                      />
                    ))}
                  </div>

                  {/* Content */}
                  <p className="text-gray-700 leading-relaxed mb-6 italic flex-grow">
                    &ldquo;{testimonial.content}&rdquo;
                  </p>

                  {/* Screenshot if available */}
                  {testimonial.screenshot && (
                    <div className="mb-4">
                      <button
                        onClick={() => openScreenshot(testimonial.screenshot)}
                        className="w-full focus:outline-none focus:ring-2 focus:ring-black"
                        aria-label={`View enlarged screenshot from ${testimonial.name}`}
                      >
                        <img
                          src={testimonial.screenshot}
                          alt={`Feedback from ${testimonial.name}`}
                          className="w-full h-48 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                        />
                      </button>
                      <p className="text-xs text-gray-500 mt-2 text-center">
                        Click to enlarge
                      </p>
                    </div>
                  )}

                  {/* Author */}
                  <div className="flex items-center">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover mr-4"
                    />
                    <div>
                      <div className="font-semibold text-black">
                        {testimonial.name}
                      </div>
                      <div className="text-sm text-gray-600">
                        {testimonial.role}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Screenshot Lightbox */}
        {selectedScreenshot && (
          <button
            className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center p-4"
            onClick={closeScreenshot}
            onKeyDown={e => {
              if (e.key === 'Escape') {
                closeScreenshot();
              }
            }}
            aria-label="Close screenshot"
          >
            <button
              onClick={closeScreenshot}
              className="absolute top-6 right-6 text-white hover:text-gray-300 transition-colors z-50"
              aria-label="Close"
            >
              <X size={32} />
            </button>
            <div onClick={e => e.stopPropagation()} role="presentation">
              <img
                src={selectedScreenshot}
                alt="Feedback screenshot"
                className="max-w-full max-h-[90vh] object-contain"
              />
            </div>
          </button>
        )}

        {/* CTA Section */}
        {false && (
          <section className="py-20 bg-gray-50">
            <div className="max-w-4xl mx-auto px-6 text-center">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight">
                Join Our Happy Clients
              </h2>
              <p className="text-xl text-gray-600 mb-10">
                Let us capture your special moments and create memories that
                last a lifetime
              </p>
              <a
                href="/contact"
                className="inline-block bg-black text-white px-10 py-4 text-sm tracking-widest uppercase hover:bg-gray-900 transition-colors zoom-hover"
              >
                Book Your Session
              </a>
            </div>
          </section>
        )}
      </Layout>
    </>
  );
};

export default Testimonials;
